__turbopack_context__.v({
  "container": "Layout-module__hBxhlq__container",
  "content": "Layout-module__hBxhlq__content",
  "contentContainer": "Layout-module__hBxhlq__contentContainer",
  "header": "Layout-module__hBxhlq__header",
  "sidebar": "Layout-module__hBxhlq__sidebar",
});
